import { createFileRoute, redirect } from '@tanstack/react-router'

import { MAP_SNAPSHOTS_ENABLED } from '@/constants'
import { requirePermission } from '@/utils/auth'
import MapSnapshotsPage from '@/components/MapSnapshots/MapSnapshotsPage'

export const Route = createFileRoute('/map-snapshots')({
  beforeLoad: () => {
    if (!MAP_SNAPSHOTS_ENABLED) {
      throw redirect({ to: '/' })
    }
    requirePermission('map_snapshot')
  },
  component: MapSnapshotsPage,
})
